var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinWithTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-22 -152C-22 -156.418 -18.4183 -160 -14 -160H278C282.418 -160 286 -156.418 286 -152V40.5443C286 44.9626 282.418 48.5443 278 48.5443H-14C-18.4183 48.5443 -22 44.9626 -22 40.5443V-152Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.456055C4.97662 0.456055 0.5 4.93375 0.5 10.4561C0.5 13.535 1.89154 16.2878 4.07974 18.1227L10.5 24.5441L16.9203 18.1238C19.1085 16.289 20.5 13.5361 20.5 10.4571C20.5 4.93375 16.0231 0.456055 10.5 0.456055ZM10.5 17.1191C6.99332 17.1191 4.15067 14.2764 4.15067 10.7697C4.15067 7.26413 6.99332 4.42148 10.5 4.42148C14.0067 4.42148 16.8493 7.26413 16.8493 10.7708C16.8493 14.2764 14.0067 17.1191 10.5 17.1191Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4385 8.27394C14.0674 7.89966 13.4631 7.89546 13.0878 8.26662L9.72134 11.5934L8.71141 10.0378C8.42495 9.59553 7.83322 9.47005 7.39096 9.75651C6.94873 10.043 6.82326 10.6347 7.10972 11.077L8.69991 13.5276C8.74382 13.6154 8.80132 13.698 8.8745 13.7722C9.06164 13.9614 9.30734 14.0555 9.55303 14.0555C9.79559 14.0555 10.0381 13.9635 10.2242 13.7806L14.4303 9.62488C14.8056 9.25373 14.8087 8.64824 14.4385 8.27394Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinWithTick);
export default __webpack_public_path__ + "static/media/location-pin-with-tick.41280b0c27ff3cd69cecbdd4d6d2e27f.svg";
export { ForwardRef as ReactComponent };